// extracted by mini-css-extract-plugin
export default {"heading":"AdditionalInfo_heading__9zfoe","container":"AdditionalInfo_container__gO0v5"};